import { render } from "./ArtistsView.vue?vue&type=template&id=9ff1b64a&scoped=true"
import script from "./ArtistsView.vue?vue&type=script&lang=js"
export * from "./ArtistsView.vue?vue&type=script&lang=js"

import "./ArtistsView.vue?vue&type=style&index=0&id=9ff1b64a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ff1b64a"]])

export default __exports__